export default __webpack_public_path__ + "static/media/4_Intro.e8a80b11.mp4";